import IconButton from "~/ui/IconButton";
import isNil from "~/kernel/validation/isNil";
import type { PaginatedResponse } from "../kernel/pagination/paginatedResponse";

type Props<T> = {
  result: Pick<
    PaginatedResponse<T>,
    "pageStart" | "pageEnd" | "totalCount" | "previousPage" | "nextPage"
  >;
  onNext: () => void;
  onPrevious: () => void;
};

export default function PaginationControls<T>({
  result,
  onNext,
  onPrevious,
}: Props<T>) {
  return (
    <div className="flex flex-row items-center justify-end gap-2">
      <div className="whitespace-nowrap">
        {result.pageStart + 1}-{result.pageEnd} av {result.totalCount}
      </div>
      <IconButton
        icon="chevron-left"
        size="bodyText"
        disabled={isNil(result.previousPage)}
        onClick={() => onPrevious()}
      />
      <IconButton
        disabled={isNil(result.nextPage)}
        size="bodyText"
        icon="chevron-right"
        onClick={() => onNext()}
      />
    </div>
  );
}
